import { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import geoJson from "../data/bd-geo-units.json";
import { GeoData } from "../types/geo_units";
import { useLang } from "../contexts/LangContext";

const geoData = geoJson as GeoData;
export interface AddressPickerHandle {
  commit: () => void;
  address?: {
    district?: string;
    upazila?: string;
    union?: string;
    village?: string;
  };
}

export default forwardRef(function AddressPicker(
  {
    address,
    onChange
  }: {
    address?: {
      district?: string;
      upazila?: string;
      union?: string;
      village?: string;
    };
    onChange: (address: Record<string, string>) => void;
  },
  ref
) {
  const { lang } = useLang();

  const [district, setDistrict] = useState("");
  const [upazila, setUpazila] = useState("");
  const [union, setUnion] = useState("");
  const [village, setVillage] = useState("");
  const [villageInput, setVillageInput] = useState("");
  const [haltChangeEvents, setHaltChangeEvents] = useState(false);

  useEffect(() => {
    if (address) {
      setHaltChangeEvents(true); // stop triggering onChange temporarily

      setDistrict(address.district || "");
      setUpazila(address.upazila || "");
      setUnion(address.union || "");
      setVillage(address.village || "");
      setVillageInput(address.village || "");

      setTimeout(() => {
        setHaltChangeEvents(false);
      }, 0);
    }
  }, [address]);

  useEffect(() => {
    console.log("Address changed:", { district, upazila, union, village });
    onChange({ district, upazila, union, village });
  }, [district, upazila, union, village]);


  useImperativeHandle(ref, () => ({
    commit: () => {
      setVillage(villageInput);    
      onChange({ district, upazila, union, village });
      // window.alert("Address committed: " + JSON.stringify({ district, upazila, union, village }));      
    },
    address: {
      district,
      upazila,
      union,
      village: villageInput.trim(),
    },
  }));

  const districts = geoData.divisions
    .flatMap((div) => div.districts)
    .sort((a, b) => {
      const nameA = lang === "bn" ? a.name_bn : a.name_en;
      const nameB = lang === "bn" ? b.name_bn : b.name_en;
      return nameA.localeCompare(nameB);
    });
  /* Bring Noakhali district to the top */
  const noakhaliIndex = districts.findIndex((d) => d.name_en === "Noakhali");
  if (noakhaliIndex > 0) {
    const noakhaliDistrict = districts.splice(noakhaliIndex, 1)[0];
    districts.unshift(noakhaliDistrict);
  }

  const upazilas = districts.find((d) => d.id === district)?.upazilas || [];
  const unions = upazilas.find((u) => u.id === upazila)?.unions || [];

  const label = (obj: { name_en: string; name_bn: string }) =>
    lang === "bn" ? obj.name_bn : obj.name_en;

  return (
    <div className="grid grid-cols-2 gap-3">
      <select
        className="input-base select-base select-small"
        value={district}
        onChange={(e) => {
          // if (haltChangeEvents) return;
          setDistrict(e.target.value);
          //setUpazila("");
          //setUnion("");
        }}
      >
        <option value="">
          {lang === "bn" ? "-- জেলা --" : "-- District --"}
        </option>
        {districts.map((d) => (
          <option key={d.id} value={d.id}>
            {label(d)}
          </option>
        ))}
      </select>

      <select
        className="input-base select-base select-small"
        disabled={!upazilas.length}
        value={upazila}
        onChange={(e) => {
          //if (haltChangeEvents) return;
          setUpazila(e.target.value);
          //setUnion("");
        }}
      >
        <option value="">
          {lang === "bn" ? "-- উপজেলা --" : "-- Upazila --"}
        </option>
        {upazilas.map((u) => (
          <option key={u.id} value={u.id}>
            {label(u)}
          </option>
        ))}
      </select>

      <select
        className="input-base select-base select-small"
        disabled={!unions.length}
        value={union}
        onChange={(e) => {
          //if (haltChangeEvents) return;
          setUnion(e.target.value);
        }}
      >
        <option value="">
          {lang === "bn" ? "-- ইউনিয়ন --" : "-- Union --"}
        </option>
        {unions.map((u) => (
          <option key={u.id} value={u.id}>
            {label(u)}
          </option>
        ))}
      </select>

      {/* Input for village name */}
      <input
        type="text"
        className="input-base input-small"
        placeholder={lang === "bn" ? "-- গ্রাম --" : "-- Village --"}
        value={villageInput}
        onChange={(e) => {
          setVillageInput(e.target.value.trim());
        }}
        onBlur={(e) => {
          setVillage(e.target.value.trim());
        }}
      />

      {/* <MultilingualTextInput
        ref={villageInputRef}
        value={village}
        onCommit={(value) => {
          console.log("Village committed:", value);
          setVillage(value?.trim());
        }}
        placeholder={lang === "bn" ? "-- গ্রাম --" : "-- Village --"}
        className="input-base input-small"
      /> */}
    </div>
  );
});
